import { Button, Card, CardActions, CardContent, Dialog, DialogContent, DialogTitle, TextField } from '@mui/material'
import { Link } from 'react-router-dom';
import { countriesService } from 'services/countries.service';
import _ from 'lodash'
import { HajjImage } from 'components/HajjImage/HajjImage';
import { snack } from 'components/Snack/Snack';
import offersService from 'services/admin/offersService';
import { useRef, useState } from 'react';
import { OfferStatus } from 'components/OfferStatus';

export default function ProductCard({ offer, options, loadData }) {
    const product = offer.product;
    const hideButtons = _.get(options, 'hideButtons')
    const [open, setOpen] = useState(false)

    const newPriceRef = useRef(null)
    const newStockRef = useRef(null)

    const hideOffer = async () => {
        try {
            const isConfirmed = window.confirm('Вы точно хотите снять с прожади товар?')

            if (isConfirmed) {
                await offersService.hide(offer.id);
                snack('Товар успешно снят с продажи!')
                loadData && loadData()
            }
        } catch (ex) {
            console.error('При снятии с продажи товара вышла ошибка:', ex?.message)
        }
    };

    const updatePriceAndStock = async () => {
        try {
            const price = newPriceRef.current.value
            const stock = newStockRef.current.value

            await offersService.updatePriceAndStock(offer.id, { price, stock })
            snack('Цена и остатки успешно изменены!')
            loadData && loadData()
            setOpen(false)
        } catch (error) {
            console.error('При изменении цены и остатков товара вышла ошибка:', error?.message)
        }
    }

    return (
        <div>
            <Card className='p-16'>
                <CardContent>
                    <div className='flex gap-16'>
                        <div style={{ borderRadius: '8px', overflow: 'hidden', flex: 0.10 }}>
                            <HajjImage image={product.photo} />
                        </div>
                        <div className='profile' style={{ flex: 1 }}>
                            <h3>{product.name}</h3>
                            <div className='m-t-8'>Цена: {offer.price} {offer.currency}</div>
                            <div className='m-t-8'>Остатки: {offer.stock} шт.</div>
                            <div className='m-t-8'>Наличие в магазинах: {offer.salePoint?.name} (г. {offer.salePoint?.city?.name})</div>
                            <h5 className='m-t-8'>{product.category?.name}</h5>
                            <div className='m-t-8'>{countriesService.getAll(product.country)?.name}</div>
                            <div className='m-t-8'>{product.city?.name}</div>
                            <div className='m-t-8'>{product.address}</div>
                            {product.website ? <div className='m-t-8'>
                                <a href={product.website} className='color-blue' rel="noreferrer" target="_blank">{product.website}</a>
                            </div> : <></>}
                        </div>
                        <div className='m-b-8 color-gray m-l-auto' style={{ marginLeft: 'auto', width: 'fit-content' }}>
                            <div>Код товара: {product.id}</div>
                            <div>Код предложения: {offer.id}</div>
                            <OfferStatus status={offer.status} />
                        </div>
                    </div>
                </CardContent>
                {hideButtons ? <></> : <CardActions className='justify-end'>
                    {/* <Link to={`../media/${product.id}`}>
                        <Button size="small">Добавить изображения</Button>
                    </Link> */}
                    <Link onClick={() => setOpen(true)}>
                        <Button size="small">Изменить цену и остатки</Button>
                    </Link>
                    <Link to={`../edit/${product.id}?offerID=${offer.id}`}>
                        <Button size="small">Редактировать карточку товара</Button>
                    </Link>
                    <Link onClick={() => hideOffer(offer)}>
                        <Button size="small">Снять с продажи</Button>
                    </Link>
                </CardActions>}
            </Card>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Изменить цену и остатки</DialogTitle>
                <DialogContent>
                    <p className="m-b-16">Если не указать цену и остатки, товар попадёт в "Сняты с продажи", вы сможете заполнить их позже</p>
                    <p className="m-b-16">Точка продаж: <strong>{offer.salePoint?.name} (г. {offer.salePoint?.city?.name})</strong></p>
                    <div className='flex flex-col gap-16 p-8'>
                        <TextField label="Цена, ₸" defaultValue={offer.price} inputRef={newPriceRef} />
                        <TextField label="Остатки от 0 до 10000 шт" defaultValue={offer.stock} inputRef={newStockRef} />
                        <div className='flex gap-16'>
                            <Button onClick={() => setOpen(false)}>Отменить</Button>
                            <Button variant='contained' onClick={() => updatePriceAndStock(offer)}>Изменить</Button>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}
